import { StepDetailBreaker } from "components/CC/RunHistory/StepDetails/StepDetailBreaker";
import { StepDetailCondition } from "components/CC/RunHistory/StepDetails/StepDetailCondition";
import { StepDetailDelay } from "components/CC/RunHistory/StepDetails/StepDetailDelay";
import { StepDetailEnd } from "components/CC/RunHistory/StepDetails/StepDetailEnd";
import { StepDetailHttp } from "components/CC/RunHistory/StepDetails/StepDetailHttp";
import { StepDetailIntegration } from "components/CC/RunHistory/StepDetails/StepDetailIntegration";
import { StepDetailModify } from "components/CC/RunHistory/StepDetails/StepDetailModify";
import { StepDetailSet } from "components/CC/RunHistory/StepDetails/StepDetailSet";
import { StepDetailWebhook } from "components/CC/RunHistory/StepDetails/StepDetailWebhook";
import { extractStepSummary, StepLogContext } from "components/CC/RunHistory/StepDetails/utils/extractStepSummary";
import { StepSummary } from "components/CC/RunHistory/StepDetails/utils/types";
import { FC } from "react";

import StepRunData = Paldock.LaravelConnectionCreator.Data.StepRunData;

interface StepDetailRendererProps {
    stepRun: StepRunData;
    logContext?: StepLogContext;
}

const STEP_TYPE_MAP = {
    http: StepDetailHttp,
    webhook: StepDetailWebhook,
    modify: StepDetailModify,
    set: StepDetailSet,
    breaker: StepDetailBreaker,
    delay: StepDetailDelay,
    integration: StepDetailIntegration,
    condition: StepDetailCondition,
    success: StepDetailEnd,
    // connection: placeholder only — detail view not yet implemented for this step type
} as Record<string, FC<{ extractedData: StepSummary }>>;

export const StepDetailRenderer: FC<StepDetailRendererProps> = ({ stepRun, logContext }) => {
    if (!stepRun.type) return null;
    const Component = STEP_TYPE_MAP[stepRun.type];

    if (!Component) {
        return null;
    }

    const extractedData: StepSummary | null = extractStepSummary(stepRun, logContext);

    if (!extractedData) {
        return null;
    }

    return <Component extractedData={extractedData} />;
};
